import styled from 'styled-components';

import { Textarea } from '@dreryk/react-components';

export const StyledReviewRequestDecisionJustificationTextarea = styled(Textarea)`
   height: 126px;
`;

StyledReviewRequestDecisionJustificationTextarea.displayName = 'StyledReviewRequestDecisionJustificationTextarea';
